/**
 * Masternodes Listing page, which servers for the '/masternodes/listing' route.
 *
 * <i>Copyright (c) 2019 Energi Cryptocurrency - https://energi.world</i><br>
 * Proprietary License
 *
 *
 * @module pages/masternodesCollateral.jsx
 * @class MasterNodesPage
 * @since 0.3.7
*/

import React from 'react';
import Seo from '../../components/seo';
import Layout from '../../components/layout';
import MasternodesCollateral from '../../components/subpages/masternodes/collateral';

const MasternodeCollateralPage = ({pageContext, location}) => (
    <div className="pure-g">
        <Seo lang={pageContext.langInfo.lang} title="Masternode Collateral" />
        <Layout location={location} pageContext = {pageContext} />
        <MasternodesCollateral {...pageContext} {...location} />
    </div>
);

export default MasternodeCollateralPage;
